<template>
  <div class="scanner-container">
    <transition name="fade"
      ><alert-modal
        v-if="alertShow"
         :contents="this.contentAlert"
        @close="this.closeAlertModal"
    /></transition>
    <div class="title font-bold">{{ $t("main.scanqr") }}</div>
    <div class="subtitle">{{ $t("main.scanqrDesc") }}</div>
    <div class="camera-container">
      <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>
    </div>
    <div class="footer-btn">
      <div class="code-button">
        <button class="code-btn btn-right font-regular" @click="gotoScanBarcode()">
          {{ $t("main.scanBarcodeBtn") }}
        </button>
      </div>
      <div class="scan-button">
        <button class="scan-btn btn-center font-regular">
          {{ $t("main.scanQrcodeBtn") }}
        </button>
      </div>
      <div class="code-button">
        <button class="code-btn btn-left font-regular" @click="gotoTypeCode()">
          {{ $t("main.typeCode") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import alertModal from "@/components/dialog/alert_modal.vue";
import * as ApiMerchants from "@/utill/api/merchants";
import { token } from "@/utill/jwt";
export default {
  components: {
    "qrcode-stream": QrcodeStream,
    "alert-modal": alertModal,
  },
  data() {
    return {
      error: "",
      alertShow: false,
      textDecode: "",
      contentAlert: {},
    };
  },
  methods: {
    gotoScanBarcode() {
      this.$router.replace("scanbarcode");
    },
    gotoTypeCode() {
      this.$router.push("typecode");
    },
    onDecode(result) {
      this.textDecode = result;
      // this.showAlertModal(result, "test description");
      this.getCouponDetail(result);
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
        console.log(error);
      }
    },
    showAlertModal(title, subtitle) {
      this.contentAlert = {
        title: title,
        desc: subtitle,
        moreDetail: null,
      };
      this.alertShow = true;
    },
    getCouponDetail(code) {
      const body = {
        code: code,
        // eslint-disable-next-line @typescript-eslint/camelcase
        merchant_id: token.getDomain(),
      };
      ApiMerchants.getCouponDetail(body).then((result) => {
        if (result.successful) {
          this.$router.push("coupon_detail");
          this.$store.commit("SET_COUPON_DETAIL", result.data);
        } else {
          this.errorHandler(result);
        }
      });
    },
    errorHandler(response) {
      console.log("response", response);
      // INVALID COUPON CODE
      if (response.data.error_code == "CM010") {
        this.showAlertModal(
          this.$t("main.errorInvalidCoupon"),
          this.$t("main.errorInvalidCouponDetail")
        );
      }
    },
    closeAlertModal() {
      this.alertShow = false;
      this.$router.push("home");
    },
  },
};
</script>

<style lang="scss" scoped>
.scanner-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.4);
}

.title {
  margin-top: 30px;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.subtitle {
  text-align: center;
  font-size: 16px;
  color: white;
}

.camera-container {
  width: 90%;
  margin: 30px 0px;
  align-self: center;
}

.footer-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: absolute;
  bottom: 10%;
  align-self: center;
}

.scan-button {
  justify-content: right;
}

.scan-btn {
  min-width: 90px;
  width: auto !important;
  height: 35px;
  color: black;
  background-color: #e8e8e8;
  border: none;
  box-shadow: 0px 2px 3px #d6d6d6;
  transition: 0.15s;
  &:hover {
    background-color: #dcdcdc;
  }
  &:focus {
    outline: 0;
  }
}

.code-button {
  justify-content: left;
}

.code-btn {
  width: auto;
  min-width: 90px;
  height: 35px;
  color: black;
  background-color: #ffffff;
  border: none;
  box-shadow: 0px 2px 3px #d6d6d6;
  transition: 0.15s;
  &:hover {
    background-color: #dcdcdc;
  }
  &:focus {
    outline: 0;
  }
}

.btn-left {
  border-radius: 0px 3px 3px 0px;
}

.btn-right {
  border-radius: 3px 0px 0px 3px;
}

.btn-center {
  border-radius: 0px 0px 0px 0px; 
}
</style>
